import React from 'react';
import './index.scss';
import { motion } from 'framer-motion';
import CustomSpinner from '../CustomSpinner';
import { buttonVariants } from '../../assets/framer/styles';

const CustomButton = ({
  text,
  onClick,
  disabled,
  loading,
  secondary
}) => {
  return (
    loading ? (
      <CustomSpinner />
    ) : (
      <motion.button
        className={`
          ${secondary ? 'custom-button-2' : 'custom-button'}
          ${disabled ? 'disabled' : ''}
        `}
        onClick={onClick}
        disabled={disabled}
        variants={buttonVariants}
        initial="hidden"
        animate="visible"
      >
        {text}
      </motion.button>
    )
  );
};

export default CustomButton;
